import { useState } from "react";
// import axios from 'axios';
import { connect } from "react-redux";
import HourRow from "./HourRow";
import InconsistencyRow from "./InconsistencyRow";

import { Actions as PAYROLL_ACTIONS } from "../../store/actions/payrollActions";

import { ArrowDownTrayIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import apiURL from "../../store/actions/apiURL";
import { format, startOfISOWeek, setISOWeek, lastDayOfISOWeek } from 'date-fns'

const getDateOfISOWeek = (w, y) => {
  var simple = new Date(y, 0, 1 + (w - 1) * 7);
  var dow = simple.getDay();
  var ISOweekStart = simple;
  if (dow <= 4)
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
  else
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
  return ISOweekStart;
}

const weeklyKeysToUse = (key,lastDate) => {
  const keyParts = key.split('.')

  const date = getDateOfISOWeek(keyParts[1],keyParts[0])
  date.setDate(date.getDate() + 6)

  return date <= new Date(lastDate)

}

const HoursUnder = ({
	//props
	close,
	employees,
	employeeByReference,
	isMonthly,
	isWeekly,
	setSubmitted,

	// from redux
	processTimesheets,
	downloadReport,
	data,
	inconsistencies,
	endDate,
	noData,
	allProcessed,
}) => {
	console.log("employees", employees, "data", data);

	const [confirmSubmission, setConfirmSubmission] = useState(false);
	// const [submitted, setSubmitted] = useState(false);
	const [saving, setSaving] = useState(false);

	const submitAll = () => {
		const currentUnderHours = localStorage.getItem("timesheetUnderHours");

		const currentUnderHoursObject = (currentUnderHours && JSON.parse(currentUnderHours)) || {};

		setSaving(true);
		console.log("saving under hours");
		fetch(apiURL + "/settings/under-hours", {
			// fetch('http://localhost:3000/report/templates' , {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				endDate,
				underHours: currentUnderHoursObject,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// obtained data
				setSubmitted(true);

				localStorage.setItem("timesheetUnderHours", JSON.stringify({}));

				console.log("saved mapping", data);

				processTimesheets();
			});
	};

	if (saving) {
		return (
			<div>
				<h4>Saving your changes. Please wait...</h4>
			</div>
		);
	}

	if (confirmSubmission) {
		return (
			<div>
				<h4>Are you sure you want to submit?</h4>

				<p
					style={{
						fontSize: "12px",
						marginTop: 5,
						marginBottom: 15,
					}}>
					Once we process your timesheets, timesheets cannot be edited unless each payslip is individually reverted by clicking on the clock item beside it.
					If reverted, you will need to proceess timesheets again to re-calculate the hours.
				</p>
				<p
					style={{
						fontSize: "12px",
						marginTop: 5,
						marginBottom: 15,
					}}>
					There is no support and/or availability to revert all timesheets at once.
				</p>
				<div
					className="btn btn-danger pull-left"
					onClick={() => setConfirmSubmission(false)}
					style={{
						position: "absolute",
						bottom: "20px",
						left: "20px",
					}}
				>
					No, Take me Back
				</div>
				<div
					className="btn btn-success pull-right"
					onClick={submitAll}
					style={{
						position: "absolute",
						bottom: "20px",
						right: "20px",
					}}
				>
					Confirm & Submit All
				</div>
			</div>
		);
	}

	if (noData) {
		return (
			<div>
				<h4>No timesheets available for processing</h4>
				<ul style={{ marginTop: "20px" }}>
					<li>
						<h5>Did you already process them?</h5>
						<p>
							No worries, just close this pop-up. The hours should be pre-filled in your payroll.
							<br />
							PS. If you have full-timers, note that hours always remain 173.33 when paying monthly,
							unless you've given unpaid leave.
						</p>
					</li>
					<li>
						<h5>Did you forget to Import timesheets?</h5>
						<p>
							<Link to="/organisation/timesheets/">Click here to the timesheet page</Link> once you
							import, come back to process them.
						</p>
					</li>
					<li>
						<h5>Need Help?</h5>
						<p>Use the chat/get in touch icon on the bottom right.</p>
					</li>
				</ul>
			</div>
		);
	}

	const inconsistencyReport = inconsistencies?.length > 0 && (
		<div>
			<h4>There are {inconsistencies.length} employees with non-matching pay items<br/> between your T&A System and Buddy</h4>
			<p
				style={{
					fontSize: "12px",
					marginTop: 5,
					marginBottom: 15,
				}}>
				Please review the below and ensure that the hours and pay are correct before submitting.
				Overtime rates may show as invalid when Buddy is not able to match the calculated rate, with the various basic rates available on the Employee's profile.
			</p>

			<table
				className="table table-hover no-footer"
				role="grid"
			>
				<thead>
					<tr role="row">
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Employee
						</th>
						<th
							className="sorting_disabled"
							rowSpan="1"
							colSpan="1"
						>
							Pay Item(s)
						</th>
					</tr>
				</thead>
				<tbody>
					{inconsistencies.map((item, index) => (
						<InconsistencyRow
							item={item}
							index={index}
							key={index}
						/>
					))}
				</tbody>
			</table>
			<p
				style={{
					fontSize: "12px",
					marginTop: 5,
					marginBottom: 15,
				}}>
				Proceeding without resolving these issues; may result in incorrect pay for your employees.
			</p>
		</div>
	);

	const hoursUnderReport = data?.length > 0 &&  <div>
		<h4>There are {data.length} Employees that seem to have worked less than their contracted hours <br/>
			or had a salary change this pay period.</h4>
		<table
			className="table table-hover no-footer"
			role="grid"
			style ={{
				marginTop: 15,
			}}
		>
			<thead>
				<tr role="row">
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
					>
						Employee
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
						title="Leave Balance till end of Year"
					>
						Lv Bal{" "}
						<InformationCircleIcon
							className="h-6 w-6"
							style={{
								display: "inline",
								verticalAlign: "text-top",
							}}
						/>
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
						title="Leave Accumulated to Date"
					>
						Lv 2D{" "}
						<InformationCircleIcon
							className="h-6 w-6"
							style={{
								display: "inline",
								verticalAlign: "text-top",
							}}
						/>
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
					>
						Target
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
					>
						Hours<sup>1</sup>
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
					>
						Under
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
						style={{ minWidth: "140px" }}
					>
						Action
					</th>
					<th
						className="sorting_disabled"
						rowSpan="1"
						colSpan="1"
					></th>
				</tr>
			</thead>
			<tbody>
				{data.map((item, index) => (
					<HourRow
						item={item}
						index={index}
						key={index}
						isMonthly={isMonthly}
						isWeekly={isWeekly}
						employeeByReference={employeeByReference}
					/>
				))}
			</tbody>
		</table>


		<div
			style={{
				fontSize: "12px",
				marginBottom: 15,
			}}
		>
			<sup>1</sup>Employees which have the necessary amount of basic hours as per their respective agreements
			are not visible here. Furthermore the number of hours shown is only the basic hours, excluding any
			overtime.
			<br />
			<sup>2</sup>Employees which had a change of salary mid-month are highlighted with an orange name. These
			may include employees that change from a part-time to a full-time role or viceversa.
		</div>
	</div>

	const allGood = data?.length == 0 && inconsistencies?.length == 0 && (
		<div>
			<h4>{allProcessed} Employees Good to Go</h4>
			<p
				style={{
					fontSize: "12px",
					marginTop: 5,
					marginBottom: 15,
				}}>
				All employees have worked their contracted hours and have no inconsistencies were found in their pay items.
				Looks like you're ready to process your timesheets.
			</p>

			<p
				style={{
					fontSize: "12px",
					marginTop: 5,
					marginBottom: 15,
				}}>
				If you want to cross-check the numbers before proceeding, grab yourself an excel report.
			</p>

		</div>
	)

	return (
		<div>
			{inconsistencyReport ? inconsistencyReport : ``}
			{hoursUnderReport ? hoursUnderReport : ``}
			{allGood ? allGood : ``}

			<div
				className="btn btn-success pull-left"
				onClick={() => downloadReport()}
			>
				<ArrowDownTrayIcon
					className="w-6 h-6 mr-3"
					style={{ verticalAlign: "text-bottom" }}
				/>
				Download Report
			</div>

			<div
				className="btn btn-success pull-right"
				onClick={() => setConfirmSubmission(true)}
			>
				Confirm & Submit All
			</div>
		</div>
	);
};

const mapStateToProps = (state, {isWeekly,isMonthly}) => {
	const payPeriodDetails = state.payroll && state.payroll.payPeriodDetails;

	const alwaysExactHours = state.company?.settings?.alwaysExactHours
	const endDate = payPeriodDetails.overtimeCutOff ? payPeriodDetails.overtimeCutOff : payPeriodDetails.periodEnd;

	// let processedTimesheets = state.payroll.processedTimesheets

	let inconsistencies = state?.payroll?.processedTimesheets?.filter?.((item) => {
		return item?.inconsistencies?.allowances?.length > 0 || item?.inconsistencies?.overtimes?.length > 0;
	})

	const employees = state?.payroll?.employees;

	let processedTimesheets = state?.payroll?.processedTimesheets?.filter?.((item) => {

		  const hasMultipleSalaries = item.salaryData && Object.keys(item.salaryData).length > 1

		  const monthlyHours = item.basicHours // calculateTotalHours(item.month)
		  // when using monthly - we should compare to 1 month not all months
		  const monthlyTargetMonthKey = Object.keys(item.targetMonth)[Object.keys(item.targetMonth).length-1]
		  const monthlyTargetHours = item.targetMonth && item.targetMonth[monthlyTargetMonthKey] || 0

		  // do not show employees who have a 0 target (casuals)
		  if (monthlyTargetHours == 0){
			return false
		  }

		  const toUse = Object.keys(item.targetWeek).filter(item => weeklyKeysToUse(item,endDate));

		  const weeklyDifferenceBreakdown = {}
		  let weeklyDifference = 0
		  let weeklyBasicHours = 0
		  let weeklyTargetHours = 0
		  let weeklyHours = 0
		  let hoursWorked = item.basicHours



		  // Object.keys(item.overtime).map(key => {
		  //   hoursWorked += item.overtime[key]
		  // })

		  const weeklyBreakdown = []
		  toUse
			.sort(
			  (a, b) => {
				// sort function as 9 shows > 10 when comparing strings
				const aIsoYear = +a.split('.')[0]
				const aIsoWeek = +a.split('.')[1]

				const bIsoYear = +b.split('.')[0]
				const bIsoWeek = +b.split('.')[1]

				// console.log('aIsoWeek',aIsoWeek,'bIsoWeek',bIsoWeek)
				if ( bIsoYear < aIsoYear ){
				  return 1
				} else if (bIsoYear == aIsoYear){
				  return bIsoWeek < aIsoWeek ? 1 : -1
				} else {
				  return -1
				}

			  })
			.map(key => {

			// console.log('keyy',key,item.targetWeek[key],item.week[key])

			weeklyHours += parseFloat(item.week[key]);
			const basicHours = Math.min(item.week[key],item.targetWeek[key]);
			weeklyBasicHours += basicHours;
			weeklyTargetHours += parseFloat(item.targetWeek[key]);

			weeklyDifferenceBreakdown[key] = item.targetWeek[key] ? (item.targetWeek[key] - basicHours) : 0;
			weeklyDifference +=  weeklyDifferenceBreakdown[key]


			if (isWeekly && item?.targetWeek?.[key]){

			  console.log('item?.targetWeek?.[key]',item?.targetWeek?.[key])

			  const startingWeek = startOfISOWeek(setISOWeek(new Date(`${key.split('.')[0]}-06-01`),key.split('.')[1]))
			  const endingWeek = lastDayOfISOWeek(startingWeek)

			  const weeklyRow =
					<tr key={`${item.agreement}.${key}`} role="row">
					  <td colSpan='3'>
						<span style={{paddingLeft:15}}>
						  {format(startingWeek,'do MMM yyyy')} - {format(endingWeek,'do MMM yyyy')}
						</span>
					  </td>
					  <td>{parseFloat(item?.targetWeek?.[key]).toFixed(2) || 0}</td>
					  <td>{item.week[key].toFixed(2) || 0}</td>
					  <td>{  item.targetWeek[key] ? (item.targetWeek[key] - basicHours).toFixed(2) : 0 }</td>

					  <td colSpan='2'>

					  </td>

					</tr>

			  weeklyBreakdown.push(weeklyRow)
			}
		  })

		  const hoursDifference = isMonthly ?
										(monthlyTargetHours - monthlyHours)
										: isWeekly ?
										  weeklyDifference
										  : item.targetPeriod - item.basicHours

		  const targetHours = isMonthly ?
							monthlyTargetHours
							: isWeekly ?
							  weeklyTargetHours
							  : item.targetPeriod


		  const employee = employees.find(
			  employee => employee.id == item.agreement
			) || {}
		  const {salaries,engagementDate,terminationDate} = employee;

		  const terminated = terminationDate && terminationDate != engagementDate && terminationDate <= payPeriodDetails.periodEnd
		  const engaged = engagementDate && engagementDate > payPeriodDetails.periodStart

		  // TODO use flag for exact pay
		  const isExactPay = alwaysExactHours || terminated || engaged

		  item.hoursUnderData = {
			  hoursWorked,
			  hoursDifference,
			  targetHours,
			  hasMultipleSalaries,
			  weeklyBreakdown,
			  terminated,
			  engaged,
			  isExactPay,
			  weeklyDifference,
			  weeklyDifferenceBreakdown,
		  }

		  if (isExactPay || Math.round(hoursDifference*100) <= 0 && !hasMultipleSalaries){
			return false
		  } else {
			  return true
		  }
	});

	return {
		// ...state.leave,
		// allowanceUploadErrors: state.allowances.allowanceUploadErrors,
		// allowanceUploadProgress: state.allowances.allowanceUploadProgress,
		// processingTimesheets: state.payroll.processingTimesheets
		inconsistencies,
		alwaysExactHours,
		allProcessed: state?.payroll?.processedTimesheets?.length,
		noData: state?.payroll?.processedTimesheets?.length == 0,
		data: processedTimesheets,
		endDate,
	};
};

const mapDispatchToProps = (dispatch) => ({
	processTimesheets: () => dispatch(PAYROLL_ACTIONS.processTimesheets(false)),
	downloadReport: () => dispatch(PAYROLL_ACTIONS.downloadProcessTimesheetReport(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HoursUnder);
